// RedirectToFirstClass.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function RedirectToFirstClass() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/course/clases/1", { replace: true }); }, [navigate]);
  return null;
}
